<template>
  <div class="login-page">
    <div class="login-box">
      <h2 class="login-title">Смена пароля</h2>
      <p class="login-hint">Это ваш первый вход. Пожалуйста, установите новый пароль.</p>
      <form @submit.prevent="submit">
        <div class="login-field">
          <label>Новый пароль</label>
          <input
            v-model="newPassword"
            type="password"
            autocomplete="new-password"
            placeholder="Не менее 8 символов"
            :disabled="loading"
          />
        </div>
        <div class="login-field">
          <label>Подтверждение пароля</label>
          <input
            v-model="confirm"
            type="password"
            autocomplete="new-password"
            placeholder="Повторите пароль"
            :disabled="loading"
          />
        </div>
        <p v-if="error" class="login-error">{{ error }}</p>
        <button type="submit" :disabled="loading" class="login-btn">
          {{ loading ? "Сохранение..." : "Сохранить пароль" }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { changeAdminPassword } from "@/api";
import { mapState } from "vuex";

export default {
  name: "ChangePassword",

  data: () => ({
    newPassword: "",
    confirm: "",
    error: "",
    loading: false,
  }),

  computed: {
    ...mapState("auth", ["session"]),
  },

  mounted() {
    if (!this.session || !this.session.token) {
      this.$router.push("/login");
    }
  },

  methods: {
    async submit() {
      this.error = "";
      if (this.newPassword.length < 8) {
        this.error = "Пароль должен быть не менее 8 символов";
        return;
      }
      if (this.newPassword !== this.confirm) {
        this.error = "Пароли не совпадают";
        return;
      }
      this.loading = true;
      try {
        await changeAdminPassword(this.session.token, this.newPassword);
        const updated = { ...this.session, mustChangePassword: false };
        localStorage.setItem("Auth", JSON.stringify(updated));
        this.$router.push("/");
      } catch (err) {
        const msg = err.response && err.response.data && err.response.data.message;
        this.error = msg || "Ошибка при смене пароля";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgb(36, 40, 44);
}

.login-box {
  background: rgb(45, 50, 56);
  border-radius: 8px;
  padding: 40px 36px;
  width: 360px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4);
}

.login-title {
  text-align: center;
  color: rgb(239, 214, 169);
  margin-bottom: 10px;
  font-size: 22px;
  font-family: verdana;
  font-weight: normal;
  letter-spacing: 1px;
}

.login-hint {
  color: #aaa;
  font-size: 12px;
  font-family: verdana;
  text-align: center;
  margin-bottom: 24px;
  line-height: 1.5;
}

.login-field {
  margin-bottom: 16px;
}

.login-field label {
  display: block;
  color: #aaa;
  font-size: 12px;
  margin-bottom: 6px;
  font-family: verdana;
}

.login-field input {
  width: 100%;
  padding: 10px 12px;
  background: rgb(36, 40, 44);
  border: 1px solid #444;
  border-radius: 4px;
  color: #e0e0e0;
  font-size: 14px;
  box-sizing: border-box;
  outline: none;
  font-family: verdana;
}

.login-field input:focus {
  border-color: rgb(239, 214, 169);
}

.login-error {
  color: #e57373;
  font-size: 12px;
  margin-bottom: 12px;
  font-family: verdana;
}

.login-btn {
  width: 100%;
  padding: 11px;
  background: rgb(239, 214, 169);
  color: rgb(36, 40, 44);
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-family: verdana;
  cursor: pointer;
  margin-top: 4px;
}

.login-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.login-btn:hover:not(:disabled) {
  background: #f0d9a0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/ChangePassword.vue